import React, { Component } from 'react'
import { getInformationWithData, getDetailSO, getInformationWithDataV3 } from '../../../services/CABE';
import { AiOutlineReload, AiOutlineSearch, AiOutlineBarChart } from "react-icons/ai";
import '../../../css/dashboard.css'
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import LoadingWindow from '../../../components/LoadingWindow';
import { getIMGByItemCode, ItemDesc, NumberFormat, OrderArray, random_rgba } from '../../../functions/generalFunctions';
import { pricesFormat } from '../../../functions/pricesFormat';
import { DateFormatMAS90, getDateFromReports, OrderArrayByDateGenericLinesDesc } from '../../../functions/dateFormat';
import { ItemPerVendor, ItemsVendor, VendorDetail, Vendors } from './Class';
import { getIndexElement } from '../../../functions/searchInObject';
import ModalOrders from '../../../components/ModalComponent';
import ExcelDocument from '../../../components/ExcelDocument';
import { getValueCookie } from '../../../services/cookieService';
import { getDataSet } from '../../../functions/generateDataSetExcel';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, PointElement, LineElement, Filler } from 'chart.js';
import { Menu } from '../../../components/Menu/Menu';


export default class SalesOrderReport extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
        ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale,
            LinearScale,
            BarElement,
            Title, CategoryScale,
            LinearScale,
            PointElement,
            LineElement,

            Filler,
        );
    }
    state = {
        BodyFilter: [],
        flag: true,
        ItemVendorList: [],
        VendorItemList: [],
        AllInformation: [],
        mode: 'Item',
        ModalBody: [],
        ModalBodyFilter: [],
        ModalDetailBody: [],
        ModalFilterDetailBody: [],
        showModal1: false,
        order: true,
        currentItem: {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: '',
            TotalQuant: 0,
            TotalAmt: 0
        },
        ExcelInfo:[]
    }

    sumatoria(arreglo, llave = null) {
        let suma = 0
        for (const temp of arreglo) {
            const valor = Number(llave != null ? temp[llave] : temp)
            if (!isNaN(valor)) {
                suma += valor
            }
        }
        return suma ? suma.toFixed(2) : suma
    }

    async fetchWithSimpleRetry(data, retries = 3) {
        for (let i = 0; i < retries; i++) {
          try {
            // Try to obtain the response
            const detail = await getDetailSO('/sales/get/detail', data);
            return detail;
            
          } catch (error) {
            console.log(`Error in try ${i + 1}: ${error.message}`);
            
            if (error.message.includes('504')) {
              console.log(`Retrying... (${i + 1}/${retries})`);
            } else {
              throw error;
            }
      
            // If the error persist throw an error
            if (i === retries - 1) {
              throw new Error('Max retries reached. No se pudo obtener los datos.');
            }
          }
        }
      }

    async getVendors() {
        this.ModalLoading.current.showState(true);
        let ItemVendorList = []
        let VendorItemList = []
        let salesPerson = getValueCookie('SalesPerson')
        if(salesPerson === 'RR')
            salesPerson = '0000'
        const data = {
            idcompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
            SalespersonNo: salesPerson
        }

        let result = await getInformationWithDataV3('/sales/get/headerV2', data)
        let SalesOrder = await getInformationWithDataV3('/sales/get/headerV2', data)
        const quoteOrders = SalesOrder.data.filter(order => order.OrderType === 'Q').map(order => order.SalesOrderNo); ;

        if (result.status.code === 1) {
            const d1 = {
                OrderNo: '*',
                idCompany: Number(getValueCookie('CompanyId')),
            }
            let detail = []
            
            try {
                detail = await this.fetchWithSimpleRetry(d1);
                if (detail && detail.data && detail.data.Tabla1) {
                    let noQuotes = detail.data.Tabla1.filter(order => !quoteOrders.includes(order.SalesOrderNo))
                    noQuotes = await ItemDesc(noQuotes, 'ItemCodeDesc', 'ItemCode', true)
                    result.data = result.data.filter(order => order.OrderType === 'S')
                    for (const info of noQuotes) {
                        const VendorIndex = getIndexElement(result.data, 'SalesOrderNo', info.SalesOrderNo)
        
                        if (VendorIndex !== -1) {
        
                            const index = getIndexElement(ItemVendorList, 'ItemCode', info.ItemCode)
                            const index2 = getIndexElement(VendorItemList, 'VendorNo', result.data[VendorIndex].CustomerNo)
        
        
                            if (index === -1) {
                                let it = new ItemsVendor(info.ItemCode, info.ItemCodeDesc, info.ProductLine)
                                it.addVendor(new Vendors(result.data[VendorIndex].CustomerNo, result.data[VendorIndex].BillToName, info.QuantityOrdered, info.UnitPrice, result.data[VendorIndex].OrderDate, info.SalesOrderNo))
                                ItemVendorList.push(it)
                            } else {
                                ItemVendorList[index].addVendor(new Vendors(result.data[VendorIndex].CustomerNo, result.data[VendorIndex].BillToName, info.QuantityOrdered, info.UnitPrice, result.data[VendorIndex].OrderDate, info.SalesOrderNo))
                                ItemVendorList[index].VendorList = OrderArrayByDateGenericLinesDesc(ItemVendorList[index].VendorList, 'LastReceiptDate')
                            }
        
                            if (index2 === -1) {
                                let vend = new Vendors(result.data[VendorIndex].CustomerNo, result.data[VendorIndex].BillToName, info.QuantityOrdered, info.UnitPrice, result.data[VendorIndex].OrderDate, info.SalesOrderNo)
                                vend.addItem(new ItemPerVendor(info.QuantityOrdered, info.UnitPrice, result.data[VendorIndex].OrderDate, info.ItemCode, info.ItemCodeDesc, info.ProductLine, info.SalesOrderNo))
                                VendorItemList.push(vend)
                            } else {
                                VendorItemList[index2].addItem(new ItemPerVendor(info.QuantityOrdered, info.UnitPrice, result.data[VendorIndex].OrderDate, info.ItemCode, info.ItemCodeDesc, info.ProductLine, info.SalesOrderNo))
                                VendorItemList[index2].ItemList = OrderArrayByDateGenericLinesDesc(VendorItemList[index2].ItemList, 'LastReceiptDate')
                            }
        
                        }
                        for (const item of ItemVendorList) {
                            item.calculateTotals()
                        }
                    }
                    this.setState({ 
                        ItemVendorList: ItemVendorList, 
                        VendorItemList: SalesOrder.data, 
                        BodyFilter: ItemVendorList, 
                        mode: 'Item', 
                        AllInformation: result.data,
                        ExcelInfo: noQuotes
                    })
                } else {
                    throw new Error('La respuesta no tiene los datos esperados');
                }
            } catch (error) {
                console.error('Error al obtener o procesar los detalles:', error.message);
            }
            
        }

        this.ModalLoading.current.showState(false);

        document.getElementById("excelContainerSalesOrdersReport").classList.remove("d-none");
        document.getElementById("loadDataContainerSalesOrdersReport").classList.replace("col-12", "col-6");
    }

    valueRadioButton = async e => {
        let stat = e.target.value
        if (stat === 'Item') {
            this.setState({ BodyFilter: this.state.ItemVendorList, mode: stat })

        } else {
            this.setState({ BodyFilter: this.state.VendorItemList, mode: stat })
        }
    }

    async getVendorsList(index, it) {
        this.clearModal()
        await this.handleModalOpen("showModal1")
        this.ModalLoading.current.showState(true);

        if (this.state.mode === 'Item') {
            const data = {
                ItemCode: it.ItemCode,
                idCompany: Number(getValueCookie('CompanyId')),
            }
            const result = await getInformationWithData('/purchase/History/getDetialByItem', data)
            if (result.status.code === 1) {
                let allData = []
                let dates = []
                let date2 = []
                for (const row of result.data) {

                    const index = getIndexElement(allData, 'VendorNo', row.VendorNo)
                    const index2 = getIndexElement(dates, 'OrderDate', DateFormatMAS90(row.PurchaseOrderDate))

                    if (index === -1) {
                        let newVendorDetail = new VendorDetail(row.VendorNo, row.PurchaseName)
                        newVendorDetail.addDetailVendor(row.PurchaseOrderNo, DateFormatMAS90(row.PurchaseOrderDate), row.QuantityInvoiced, row.UnitCost)
                        allData.push(newVendorDetail)
                    } else {
                        allData[index].addDetailVendor(row.PurchaseOrderNo, DateFormatMAS90(row.PurchaseOrderDate), row.QuantityInvoiced, row.UnitCost)
                        allData[index].VendorName = row.PurchaseName
                    }

                    if (index2 === -1) {
                        dates.push({ OrderDate: DateFormatMAS90(row.PurchaseOrderDate) })
                        date2.push(DateFormatMAS90(row.PurchaseOrderDate))
                    }
                }

                let dataSet = []

                for (const Vendor of allData) {
                    let color = random_rgba()
                    const vendordata = {

                        label: Vendor.VendorName,
                        data: [],
                        borderColor: color,
                        backgroundColor: color,
                        spanGaps: true
                    }
                    for (const date of dates) {

                        const index = getIndexElement(Vendor.Detail, 'OrderDate', date.OrderDate)
                        if (index !== -1) {
                            vendordata.data.push(Vendor.Detail[index].UnitCost)
                        } else {
                            vendordata.data.push(null)
                        }
                    }
                    dataSet.push(vendordata)
                }

                const graphData = {
                    labels: date2,
                    datasets: dataSet
                }
                this.setState({ LineGraphData: graphData })
            }


            const temporal = this.state.currentItem
            temporal.ItemCode = it.ItemCode
            temporal.ItemCodeDesc = it.ItemCodeDesc
            temporal.ProductLine = it.ProductLine
            temporal.TotalAmt = it.TotalAmt
            temporal.TotalQuant = it.TotalQuantity
            temporal.itemURL = await getIMGByItemCode(it.ItemCode)
            const index2 = getIndexElement(this.state.ItemVendorList, 'ItemCode', it.ItemCode)
            const item = this.state.ItemVendorList[index2]

            await this.setState({
                ModalBody: item.VendorList,
                ModalBodyFilter: item.VendorList,
                currentItem: temporal,
                ModalDetailBody: result.data,
                ModalFilterDetailBody: result.data
            })

        } else {
            const data = {
                idCompany: Number(getValueCookie('CompanyId')),
                OrderNo: it.SalesOrderNo,
                Mode: true
            }
            const result = await getDetailSO('/sales/get/detail', data)

            if (result.status.code === 1) {
                const temporal = this.state.currentItem
                temporal.ItemCodeDesc = it.BillToName
                temporal.ItemCode = it.CustomerNo
                temporal.ProductLine = it.SalesOrderNo
                temporal.itemURL = it.OrderDate
                result.data.Tabla1 = await ItemDesc(result.data.Tabla1, 'ItemCodeDesc', 'ItemCode', true)
                this.setState({
                    ModalBody: result.data.Tabla1,
                    ModalBodyFilter: result.data.Tabla1,
                    currentItem: temporal
                })
            }

        }


        this.ModalLoading.current.showState(false);

    }

    clearModal() {
        const temporal = {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: ''
        }


        this.setState({
            ModalBody: [],
            ModalBodyFilter: [],
            currentItem: temporal,
            ModalDetailBody: [],
            ModalFilterDetailBody: []
        })
    }


    async getItemList(index, vend) {
        const index2 = getIndexElement(this.state.VendorItemList, 'VendorNo', vend.VendorNo)
        const vendor = this.state.VendorItemList[index2]
        const temporal = this.state.currentItem
        temporal.ItemCode = vend.VendorNo
        temporal.ItemCodeDesc = vend.VendorName
        temporal.TotalQuant = vend.TotalQuantity
        temporal.TotalAmt = vend.TotalPrice

        await this.setState({ ModalBody: vendor.ItemList, ModalBodyFilter: vendor.ItemList, currentItem: temporal })
        this.handleModalOpen("showModal1")


    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
    }

    handleModalOpen = (modal) => {
        this.setState({ [modal]: true })
    }

    OrderInformation(array, key, state) {
        const order = OrderArray(array, key, this.state.order)
        this.setState({ [state]: order, order: !this.state.order })
    }
    contains(parametro, busqueda) {
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }


    searchVendor = e => {

        let search = e.target.value;

        let Vendor
        if (this.state.mode === 'Item') {
            Vendor = this.state.ItemVendorList.filter((item) => {
                if (((
                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLine, search) ||
                    this.contains(item.ItemCodeDesc, search)
                ))
                ) {
                    return item
                } else {
                    return null
                }
            });

        } else {
            Vendor = this.state.VendorItemList.filter((vendor) => {
                if (((
                    this.contains(vendor.SalesOrderNo, search) ||
                    this.contains(vendor.CustomerNo, search) ||
                    this.contains(vendor.BillToName, search) ||
                    this.contains(vendor.SalespersonNo, search) ||
                    this.contains(vendor.UDF_RUTA, search)
                ))
                ) {
                    return vendor
                } else {
                    return null
                }
            });

        }

        this.setState({ BodyFilter: Vendor });
    }
    searchVendorHistory = e => {
        let search = e.target.value;

        let Vendor = this.state.ModalDetailBody.filter((vendor) => {
            if ((this.contains(vendor.VendorNo, search))
                || this.contains(vendor.PurchaseName, search)
                || this.contains(vendor.PurchaseOrderNo, search)) {
                return vendor
            } else {
                return null
            }
        })
        this.setState({ ModalFilterDetailBody: Vendor })
    }



    searchVendorModal = e => {

        let search = e.target.value;

        let Vendor = []
        if (this.state.mode === 'Item') {
            Vendor = this.state.ModalBody.filter((vendor) => {
                if (((
                    this.contains(vendor.VendorNo, search) ||
                    this.contains(vendor.VendorName, search)
                ))
                ) {
                    return vendor
                } else {
                    return null
                }
            });


        } else {
            Vendor = this.state.ModalBody.filter((item) => {
                if (((

                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLine, search) ||
                    this.contains(item.ItemCodeDesc, search)
                ))
                ) {
                    return item
                } else {
                    return null
                }
            });
        }

        this.setState({ ModalBodyFilter: Vendor });
    }


    getSalesOrderKPIs() {
        const { mode, ItemVendorList, VendorItemList } = this.state;
        if (mode === 'Item') {
            const items = ItemVendorList;
            if (!items.length) return null;
            const totalItems  = items.length;
            const totalQty    = items.reduce((s, r) => s + Number(r.TotalQuantity || 0), 0);
            const totalAmt    = items.reduce((s, r) => s + Number(r.TotalAmt || 0), 0);
            const uniqueRoutes = new Set(VendorItemList.map(o => o.UDF_RUTA).filter(Boolean)).size;
            return { totalItems, totalQty, totalAmt, uniqueRoutes, modeLabel: 'Items' };
        } else {
            const orders = VendorItemList;
            if (!orders.length) return null;
            const totalOrders  = orders.length;
            const totalAmt     = orders.reduce((s, r) => s + Number(r.NonTaxableAmt || 0), 0);
            const uniqueCustomers = new Set(orders.map(o => o.CustomerNo).filter(Boolean)).size;
            const uniqueRoutes = new Set(orders.map(o => o.UDF_RUTA).filter(Boolean)).size;
            return { totalOrders, totalAmt, uniqueCustomers, uniqueRoutes, modeLabel: 'Orders' };
        }
    }

    render() {
        const hasData = this.state.BodyFilter.length > 0;
        const kpis = hasData ? this.getSalesOrderKPIs() : null;
        const { mode } = this.state;

        const sortArrows = <span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>;

        return (
            <div className="dash-page" style={{ }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero — Load Data button lives here, no extra card needed */}
                <div style={{ marginTop: 30, background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '2rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <AiOutlineBarChart style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Sales Order Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>All open sales orders — browse by item or by order number</p>
                    </div>
                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                        {hasData && (
                            <span style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderRadius: '999px', padding: '0.3rem 1rem', fontSize: '0.8rem', fontWeight: 700 }}>
                                {this.state.BodyFilter.length.toLocaleString('en-US')} {mode === 'Item' ? 'items' : 'orders'}
                            </span>
                        )}
                        <button onClick={() => this.getVendors()} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1.1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                            <AiOutlineReload /> Load Data
                        </button>
                    </div>
                </div>

                {/* Hidden stubs — keep IDs so getVendors() DOM classList calls don't throw */}
                <div id="loadDataContainerSalesOrdersReport" style={{ display: 'none' }}></div>
                <div id="excelContainerSalesOrdersReport" className="d-none" style={{ display: 'none' }}></div>

                <div style={{ padding: '1.5rem 2rem' }}>

                    {/* KPIs */}
                    {hasData && kpis && (
                        <div className="row g-3 mb-3">
                            {mode === 'Item' ? (
                                <>
                                    <div className="col-6 col-md-3">
                                        <div className="metric-card status-primary">
                                            <div className="metric-label">Unique Items</div>
                                            <div className="metric-value">{kpis.totalItems.toLocaleString('en-US')}</div>
                                            <div className="metric-change">Distinct SKUs</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="metric-card status-success">
                                            <div className="metric-label">Total Qty Ordered</div>
                                            <div className="metric-value">{Math.round(kpis.totalQty).toLocaleString('en-US')}</div>
                                            <div className="metric-change">Units on order</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="metric-card status-warning">
                                            <div className="metric-label">Total Amount</div>
                                            <div className="metric-value">${NumberFormat(pricesFormat(kpis.totalAmt))}</div>
                                            <div className="metric-change">At order price</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="metric-card status-primary">
                                            <div className="metric-label">Routes</div>
                                            <div className="metric-value">{kpis.uniqueRoutes}</div>
                                            <div className="metric-change">Distinct routes</div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="col-6 col-md-3">
                                        <div className="metric-card status-primary">
                                            <div className="metric-label">Open Orders</div>
                                            <div className="metric-value">{kpis.totalOrders.toLocaleString('en-US')}</div>
                                            <div className="metric-change">Total open SO</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="metric-card status-warning">
                                            <div className="metric-label">Total Amount</div>
                                            <div className="metric-value">${NumberFormat(pricesFormat(kpis.totalAmt))}</div>
                                            <div className="metric-change">Outstanding value</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="metric-card status-success">
                                            <div className="metric-label">Customers</div>
                                            <div className="metric-value">{kpis.uniqueCustomers.toLocaleString('en-US')}</div>
                                            <div className="metric-change">With open orders</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="metric-card status-primary">
                                            <div className="metric-label">Routes</div>
                                            <div className="metric-value">{kpis.uniqueRoutes}</div>
                                            <div className="metric-change">Distinct routes</div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* Table card */}
                    <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
                            <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
                                {[{ key: 'Item', label: 'Item List' }, { key: 'Vendor', label: 'Order List' }].map(t => (
                                    <button key={t.key}
                                        onClick={() => this.setState({ BodyFilter: t.key === 'Item' ? this.state.ItemVendorList : this.state.VendorItemList, mode: t.key })}
                                        style={{ padding: '0.3rem 0.875rem', borderRadius: '6px', fontWeight: 700, fontSize: '0.8rem', cursor: 'pointer', border: 'none', background: mode === t.key ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.1)', color: 'white' }}>
                                        {t.label}
                                    </button>
                                ))}
                                {/* Excel download lives here — natural placement next to the tabs */}
                                {hasData && (
                                    <div style={{ marginLeft: '0.5rem' }}>
                                        {mode === 'Item' ? (
                                            <ExcelDocument
                                                hidden={this.state.AllInformation.length === 0}
                                                archname={'Items in Sales Orders ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname={'Items ' + getValueCookie('Company')}
                                                data={getDataSet(this.state.BodyFilter, ['Item Code', 'Product Line', 'Description', 'Total Ordered', 'Total Amt($)'], ['ItemCode', 'ProductLine', 'ItemCodeDesc', 'TotalQuantity', 'TotalAmt'])}
                                                sheetname2={['All Detail']}
                                                data2={[getDataSet(this.state.ExcelInfo, ['Sales Order', 'Item Code', 'Description', 'Quantity Ordered', 'Unit Price ($)', 'Total Amt ($)'], ['SalesOrderNo', 'ItemCode', 'ItemCodeDesc', 'QuantityOrdered', 'UnitPrice', 'ExtensionAmt'])]}
                                            />
                                        ) : (
                                            <ExcelDocument
                                                hidden={this.state.BodyFilter.length === 0}
                                                archname={'Sales Orders ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname={'Sales Orders ' + getValueCookie('Company')}
                                                data={getDataSet(this.state.VendorItemList, ['Sales Order No', 'Customer No', 'Bill to Name', 'Order Date', 'Sales Person No', 'Route', 'Total Amt($)'], ['SalesOrderNo', 'CustomerNo', 'BillToName', 'OrderDate', 'SalespersonNo', 'UDF_RUTA', 'NonTaxableAmt'])}
                                                sheetname2={['All Detail']}
                                                data2={[getDataSet(this.state.ExcelInfo, ['Sales Order', 'Item Code', 'Description', 'Quantity Ordered', 'Unit Price ($)', 'Total Amt ($)'], ['SalesOrderNo', 'ItemCode', 'ItemCodeDesc', 'QuantityOrdered', 'UnitPrice', 'ExtensionAmt'])]}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                            {hasData && (
                                <div style={{ position: 'relative', minWidth: '260px' }}>
                                    <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                    <input type="text" autoComplete="off"
                                        placeholder={mode === 'Item' ? 'Search item code, line, description…' : 'Search order no, customer, salesperson…'}
                                        onChange={this.searchVendor}
                                        style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                                    />
                                </div>
                            )}
                        </div>
                        <div className="tableFixHeadSmall">
                            {mode === 'Item' ? (
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr>
                                            <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'ItemCode', 'BodyFilter')} style={{ cursor: 'pointer' }}>Item Code {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'ProductLine', 'BodyFilter')} style={{ cursor: 'pointer' }}>Product Line {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.BodyFilter, 'ItemCodeDesc', 'BodyFilter')} style={{ cursor: 'pointer' }}>Description {sortArrows}</th>
                                            <th className="text-center" onClick={() => this.OrderInformation(this.state.BodyFilter, 'TotalQuantity', 'BodyFilter')} style={{ cursor: 'pointer' }}>Total Ordered {sortArrows}</th>
                                            <th></th>
                                            <th className="text-end" onClick={() => this.OrderInformation(this.state.BodyFilter, 'TotalAmt', 'BodyFilter')} style={{ cursor: 'pointer' }}>Total Amt {sortArrows}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.BodyFilter.map((item, i) => (
                                            <tr onClick={() => this.getVendorsList(i, item)} key={i} style={{ cursor: 'pointer' }}>
                                                <td>{item.ItemCode}</td>
                                                <td>{item.ProductLine}</td>
                                                <td>{item.ItemCodeDesc}</td>
                                                <td className="text-center">{NumberFormat(pricesFormat(item.TotalQuantity))}</td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{NumberFormat(pricesFormat(item.TotalAmt))}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td className="text-center">{NumberFormat(pricesFormat(this.sumatoria(this.state.BodyFilter, 'TotalQuantity')))}</td>
                                            <td className="text-end">$</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(this.sumatoria(this.state.BodyFilter, 'TotalAmt')))}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            ) : (
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr>
                                            <th onClick={() => this.OrderInformation(this.state.VendorItemList, 'SalesOrderNo', 'VendorItemList')} style={{ cursor: 'pointer' }}>Sales Order No {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.VendorItemList, 'CustomerNo', 'VendorItemList')} style={{ cursor: 'pointer' }}>Customer No {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.VendorItemList, 'BillToName', 'VendorItemList')} style={{ cursor: 'pointer' }}>Customer Name {sortArrows}</th>
                                            <th className="text-center" onClick={() => this.OrderInformation(this.state.VendorItemList, 'OrderDate', 'VendorItemList')} style={{ cursor: 'pointer' }}>Order Date {sortArrows}</th>
                                            <th className="text-center" onClick={() => this.OrderInformation(this.state.VendorItemList, 'SalespersonNo', 'VendorItemList')} style={{ cursor: 'pointer' }}>Salesperson {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.VendorItemList, 'UDF_RUTA', 'VendorItemList')} style={{ cursor: 'pointer' }}>Route {sortArrows}</th>
                                            <th></th>
                                            <th className="text-end" onClick={() => this.OrderInformation(this.state.VendorItemList, 'NonTaxableAmt', 'VendorItemList')} style={{ cursor: 'pointer' }}>Total Amt {sortArrows}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.BodyFilter.map((item, i) => (
                                            <tr key={i} onClick={() => this.getVendorsList(i, item)} style={{ cursor: 'pointer' }}>
                                                <td>{item.SalesOrderNo}</td>
                                                <td>{item.CustomerNo}</td>
                                                <td>{item.BillToName}</td>
                                                <td className="text-center">{new Date(item.OrderDate).toLocaleDateString()}</td>
                                                <td className="text-center">{item.SalespersonNo}</td>
                                                <td>{item.UDF_RUTA}</td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{NumberFormat(pricesFormat(item.NonTaxableAmt))}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td colSpan={6}></td>
                                            <td className="text-center">TOTAL</td>
                                            <td className="text-end">${NumberFormat(pricesFormat(this.sumatoria(this.state.VendorItemList, 'NonTaxableAmt')))}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            )}
                        </div>
                    </div>
                </div>

                {/* Modal */}
                <ModalOrders title={mode === 'Item' ? 'Item in Orders' : 'Order Detail'} show={this.state.showModal1} close={(modal = "showModal1") => this.handleModalClose(modal)}>
                    {mode === 'Item' ? (
                        <div>
                            {/* Item header */}
                            <div className="row mb-3 align-items-center">
                                <div className="col-sm-4 text-center">
                                    <img key={this.state.currentItem.itemURL}
                                        style={{ maxHeight: '130px', objectFit: 'contain' }}
                                        src={this.state.currentItem.itemURL !== '' ? this.state.currentItem.itemURL : '/assets/notavailable.png'} alt="ProductImg" />
                                </div>
                                <div className="col-sm-5 d-flex flex-column gap-2 justify-content-center">
                                    <div>
                                        <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.8rem', fontWeight: 700, marginRight: '0.5rem' }}>{this.state.currentItem.ItemCode}</span>
                                        <span style={{ background: 'rgba(139,92,246,0.08)', color: '#5b21b6', border: '1px solid #DDD6FE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.8rem', fontWeight: 700 }}>{this.state.currentItem.ProductLine}</span>
                                    </div>
                                    <p style={{ color: '#334155', fontWeight: 600, margin: 0 }}>{this.state.currentItem.ItemCodeDesc}</p>
                                </div>
                                <div className="col-sm-3 d-flex align-items-center justify-content-end">
                                    <ExcelDocument
                                        hidden={false}
                                        archname={'Order List per Item ' + this.state.currentItem.ItemCode + ' ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                        sheetname={'Order List ' + getValueCookie('Company')}
                                        data={getDataSet(this.state.ModalBody, ['Order No', 'Customer No', 'Customer Name', 'Order Date', 'Quantity Ordered', 'Unit Price ($)', 'Total Amt($)'], ['OrderNo', 'VendorNo', 'VendorName', 'LastReceiptDate', 'LastReceiptQuantity', 'LastUnitCost', 'TotalPrice'])}
                                    />
                                </div>
                            </div>
                            {/* Search */}
                            <div style={{ position: 'relative', marginBottom: '0.75rem' }}>
                                <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                <input type="text" autoComplete="off" placeholder="Search by Order No, Customer No, Name…"
                                    onChange={this.searchVendorModal}
                                    style={{ width: '100%', borderRadius: '8px', border: '1.5px solid #E2E8F0', padding: '0.4rem 0.75rem 0.4rem 2rem', fontSize: '0.875rem', outline: 'none' }} />
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr className="text-center">
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'OrderNo', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Order No {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'VendorNo', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Customer No {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'VendorName', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Customer Name {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastReceiptDate', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Order Date {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastReceiptQuantity', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Qty Ordered {sortArrows}</th>
                                            <th></th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'LastUnitCost', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Unit Price {sortArrows}</th>
                                            <th></th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'TotalPrice', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Total Amt {sortArrows}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.ModalBodyFilter.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-center">{item.OrderNo}</td>
                                                <td className="text-center">{item.VendorNo}</td>
                                                <td>{item.VendorName}</td>
                                                <td className="text-center">{item.LastReceiptDate ? DateFormatMAS90(item.LastReceiptDate) : 'N/A'}</td>
                                                <td className="text-center">{item.LastReceiptQuantity ? NumberFormat(pricesFormat(item.LastReceiptQuantity)) : 0}</td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{item.LastUnitCost ? NumberFormat(pricesFormat(item.LastUnitCost)) : '0.00'}</td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{item.TotalPrice ? NumberFormat(pricesFormat(item.TotalPrice)) : '0.00'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td></td><td>Totals</td><td></td><td></td>
                                            <td className="text-center">{NumberFormat(pricesFormat(this.state.currentItem.TotalQuant))}</td>
                                            <td></td><td></td>
                                            <td className="text-end">$</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(this.state.currentItem.TotalAmt))}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <div>
                            {/* Order header */}
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
                                        {[
                                            { label: 'Order No', value: this.state.currentItem.ProductLine },
                                            { label: 'Order Date', value: DateFormatMAS90(this.state.currentItem.itemURL) },
                                            { label: 'Customer No', value: this.state.currentItem.ItemCode },
                                            { label: 'Customer Name', value: this.state.currentItem.ItemCodeDesc },
                                        ].map((f, i) => (
                                            <div key={i} style={{ background: '#F8FAFC', borderRadius: '8px', padding: '0.4rem 0.875rem', border: '1px solid #E2E8F0' }}>
                                                <div style={{ fontSize: '0.68rem', color: '#64748B', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{f.label}</div>
                                                <div style={{ fontWeight: 700, color: '#0F172A', fontSize: '0.875rem' }}>{f.value}</div>
                                            </div>
                                        ))}
                                        <div style={{ marginLeft: 'auto' }}>
                                            <ExcelDocument
                                                hidden={false}
                                                archname={'Order: ' + this.state.currentItem.ProductLine + ' ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                                sheetname={'Item List Order ' + this.state.currentItem.ProductLine}
                                                data={getDataSet(this.state.ModalBodyFilter, ['Item Code', 'Product Line', 'Description', 'Quantity Ordered', 'Unit Price($)', 'Total Amt($)'], ['ItemCode', 'ProductLine', 'ItemCodeDesc', 'QuantityOrdered', 'UnitPrice', 'ExtensionAmt'])}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Search */}
                            <div style={{ position: 'relative', marginBottom: '0.75rem' }}>
                                <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }} />
                                <input type="text" autoComplete="off" placeholder="Search item code, product line, description…"
                                    onChange={this.searchVendorModal}
                                    style={{ width: '100%', borderRadius: '8px', border: '1.5px solid #E2E8F0', padding: '0.4rem 0.75rem 0.4rem 2rem', fontSize: '0.875rem', outline: 'none' }} />
                            </div>
                            <div className="tableFixHeadSmall">
                                <table className="table table-clean mb-0">
                                    <thead>
                                        <tr className="text-center">
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ItemCode', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Item Code {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ProductLine', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Product Line {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ItemCodeDesc', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Description {sortArrows}</th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'QuantityOrdered', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Qty Ordered {sortArrows}</th>
                                            <th></th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'UnitPrice', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Unit Price {sortArrows}</th>
                                            <th></th>
                                            <th onClick={() => this.OrderInformation(this.state.ModalBodyFilter, 'ExtensionAmt', 'ModalBodyFilter')} style={{ cursor: 'pointer' }}>Total {sortArrows}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.ModalBodyFilter.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-center">{item.ItemCode}</td>
                                                <td className="text-center">{item.ProductLine}</td>
                                                <td>{item.ItemCodeDesc}</td>
                                                <td className="text-center">{item.QuantityOrdered ? NumberFormat(pricesFormat(item.QuantityOrdered)) : 0}</td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{item.UnitPrice ? NumberFormat(pricesFormat(item.UnitPrice)) : '0.00'}</td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{item.ExtensionAmt ? NumberFormat(pricesFormat(item.ExtensionAmt)) : '0.00'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="tfoot">
                                        <tr>
                                            <td></td><td>Totals</td><td></td>
                                            <td className="text-center">{NumberFormat(pricesFormat(this.sumatoria(this.state.ModalBodyFilter, 'QuantityOrdered')))}</td>
                                            <td></td><td></td>
                                            <td className="text-end">$</td>
                                            <td className="text-end">{NumberFormat(pricesFormat(this.sumatoria(this.state.ModalBodyFilter, 'ExtensionAmt')))}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    )}
                </ModalOrders>
            </div>
        )
    }
}
